module.exports = "/static/assets/00afe457a03b1f4ef2fd2c5bfc2af196.png";